import Vue from "vue";
import { i18n } from '@kano/i18n';

import CryptoSentimentTooltip from './components/CryptoPriceChart/CryptoSentimentTooltip.vue'
let appInstance: Vue | null = null;
export const mountCryptoSentimentTooltip = () => {
  if (appInstance !== null) {
    appInstance.$destroy();
  }

  appInstance = new Vue({
    i18n,
    render: (h) => h(CryptoSentimentTooltip),
  }).$mount("#crypto-sentiment-tooltip");

};

mountCryptoSentimentTooltip();
